@if (languages.length > 1 && getAppThemeName() === 'db') {
  <db-menu
    design="tertiary"
    [label]="menuLabel"
  >
    @for (langOption of languages; track $index) {
      <db-menu-item>
        <button (click)="setActiveLanguage($event)">{{ langOption.toUpperCase() }}</button>
      </db-menu-item>
    }
  </db-menu>
}

<ng-template #menuLabel>
  @if (!isMenuOpen) {
    <db-icon class="mr-2" color="{{color}}" size="sm">chevron-down-large</db-icon>
  }
  @if (isMenuOpen) {
    <db-icon class="mr-2" color="{{color}}" size="sm">chevron-up-large</db-icon>
  }
  @if (window.innerWidth > 850 && !iconOnly) {
    <span [style.color]="color">
      Language: {{ ' ' + currentLang?.toUpperCase() }}
    </span>
  }
  @if (window.innerWidth < 850 || iconOnly) {
    <span [style.color]="color">
      <db-icon color="{{color}}">travel</db-icon>
      {{ currentLang?.toUpperCase() }}
    </span>
  }
</ng-template>
